import React, {useState, forwardRef, useImperativeHandle, useEffect} from "react";
import {
  MFAContainer,
} from "../styled";
import Steps from "./steps/";
import {LABEL, MFA_TYPE} from "../constants";

const STEPS_CONFIG = [
  { btnLabel: "Next step", disabled: false, step: 0, backArrow: true },
  { btnLabel: "Next step", disabled: false, step: 1, backArrow: true  },
  { btnLabel: "Next step", disabled: true, step: 2, backArrow: false  },
  { btnLabel: "Finish", disabled: true, step: 3, backArrow: false  },
  { btnLabel: null, disabled: false, step: 4, backArrow: false  },
];

const MAX_CODE_LENGTH = 6;
const hasIncompleteCode = (value) => value?.length > 0 && value.length < MAX_CODE_LENGTH;

const MfaConfig = forwardRef(function MfaConfig(props, ref) {
  const [methodType, setMethodType] = useState(props.mfaType);
  const STEPS_CONFIG_INIT = props.stepsConfigOverride ? props.stepsConfigOverride : STEPS_CONFIG;

  const INIT_STEP = STEPS_CONFIG_INIT[0].step;
  const LAST_STEP_INDEX = STEPS_CONFIG_INIT.length - 1;

  //Steps
  const [stepConfig, setStepConfig] = useState(props.mfaEnabled && !props.stepsConfigOverride ? STEPS_CONFIG_INIT[4] : STEPS_CONFIG_INIT[0]);

  //Code Validation
  const [code, setCode] = useState('');
  const [validationErrors, setValidationErrors] = useState(false);

  useEffect(() => {
    if (props.addAnotherMethod) {
      goBackStepOne();
    }
  }, []);

  const getStepIndex = () => STEPS_CONFIG_INIT.findIndex((step) => step.step === stepConfig.step);

  const withResolvedBtnLabel = (config) => {
    if (!config) return config;
    const btnLabel = methodType === MFA_TYPE.EMAIL && config.step === 1 ? LABEL.SEND_CODE : LABEL.NEXT_STEP;
    return { ...config, btnLabel };
  };

  const onBackHandler = () => {
    const currentIndex = getStepIndex();
    if (currentIndex <= 0 || stepConfig.step <= INIT_STEP) {
      return stepConfig;
    }

    const previousStep = STEPS_CONFIG_INIT[currentIndex - 1];
    if (!previousStep) return stepConfig;

    setStepConfig(previousStep);
    return previousStep;
  };

  const onNextHandler = () => {
    const currentIndex = getStepIndex();
    if (currentIndex < 0 || currentIndex >= LAST_STEP_INDEX) {
      return stepConfig;
    }

    const nextStep = STEPS_CONFIG_INIT[currentIndex + 1];
    if (!nextStep) return stepConfig;

    setStepConfig(nextStep);
    return nextStep;
  };

  const selectMethodHandler = (methodSelected) => {
    setMethodType(methodSelected);
  };

  const codeHandler = (e) => {
    props.setValidateMfaCodeError(null);
    let sanitizedValue = e.currentTarget.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    if (sanitizedValue.length > MAX_CODE_LENGTH || isNaN(sanitizedValue)) {
      props.setIsMfaProcessing(false)
      return
    };

    setCode(sanitizedValue);
    setValidationErrors(hasIncompleteCode(sanitizedValue));

    if(sanitizedValue.length === MAX_CODE_LENGTH){
      props.validateMfaCode(sanitizedValue);
    }
  };

  const sendCodeByEmailHandler = async () => {
    await props.sendCodeHandler();
  };

  const goBackStepOne = () => {
    setStepConfig(STEPS_CONFIG_INIT[0]);
    props.resetSteps();
  };

  const validateForm = (code) => {
      if (!code?.length) {
          setValidationErrors(false)
          return false
      }

      if (code?.length < MAX_CODE_LENGTH || isNaN(code)) {
          setValidationErrors(true)
          props.setIsMfaProcessing(false)
          return false
      }
      setValidationErrors(false)
      return true;
  };


  useImperativeHandle(ref, () => {
    return {
      getStepConfig() {
        return withResolvedBtnLabel(stepConfig);
      },
      backAction() {
        setValidationErrors(false);
        return withResolvedBtnLabel(onBackHandler());
      },
      nextAction() {
        return withResolvedBtnLabel(onNextHandler());
      },
      getMethodSelected(){
        return methodType;
      },
      getMfaCodeEntered(){
        return validateForm(code) ? code : null;
      }
    };
  }, [stepConfig, methodType, code]);


  return (
    <>
        <MFAContainer>
        {stepConfig && (
          <Steps
            {...props}
            methodType={methodType}
            currentStep={stepConfig.step}
            selectMethodHandler={selectMethodHandler}
            code={code}
            codeHandler={codeHandler}
            validationErrors={validationErrors}
            STEPS_CONFIG_INIT={STEPS_CONFIG_INIT}
            validateForm={validateForm}
            changeMethodSettings={!!props.stepsConfigOverride}
            sendCodeByEmailHandler={sendCodeByEmailHandler}
            goBackStepOne={goBackStepOne}
          />
        )}
        </MFAContainer>
    </>
  );
});

export default MfaConfig;
export {hasIncompleteCode};
